import { Component } from 'preact';
import ClassNames from "classnames";
import SelectDayDropdown from "./SelectDayDropdown";
import SelectDayCarousel from "./SelectDayCarousel";
import RawDateContainer from "../raw/RawDateContainer";
import TextWrapper from "../../util/wrapper/TextWrapper";
import { format, parse } from "../../util/DateTimeUtils";
import { FORMAT_MASKS, WUUNDER_GREENCHOICE_URL, WUUNDER_GREENCHOICE_URL_EN } from "../../constants/constants";
import FooterForm from "../../delivery/form/FooterForm";
import { greenChoiceIcon } from "../../constants/icons";
import { getPrice, hasOptionWithGreenDate, isDateGreenForOption } from "../../util/GreenChoiceUtils";

export default class DateGroupsContainer extends Component {

    constructor(props) {
        super(props);
        const {config, changedManually} = props;

        const groups = this.groupOptionsByDate();
        const activeGroup = !changedManually && config.previousSelection && config.previousSelection.previousPreferredDate ?
            this.findPreviousGroupIndex(groups) :
            this.calculateInitiallySelectedGroupIndex(config, groups);

        this.state = {
            activeGroup
        };
    }

    onSelectGroup = (activeGroup) => {
        this.setState({
            activeGroup
        });
    };

    groupOptionsByDate = () => {
        const {options, config} = this.props;

        let groups = [];

        options && options.forEach((o, i) => {
            o.deliveryDates && o.deliveryDates.forEach(d => {

                let deliveryDate = parse(d.deliveryDate);
                let index = groups.findIndex(g => g.date.toDateString() === deliveryDate.toDateString());

                if (index === -1) {
                    groups.push({
                        date: deliveryDate,
                        groupOptions: [{...o, timeRange: d, optionOrder: i}]
                    });
                } else {
                    let optionIndex = groups[index].groupOptions.findIndex(go => go.identifier === o.identifier);

                    if (optionIndex === -1) {
                        groups[index].groupOptions.push({...o, timeRange: d, optionOrder: i});
                    }
                }

            });
        });

        groups.sort((a, b) => a.date.getTime() - b.date.getTime());

        if (config?.sortingModel?.length) {
            const sortingModel = config.sortingModel.find(sm => 'DELIVERY' === sm.tab);

            if (sortingModel) {
                if ('PRICE' === sortingModel.orderBy) {
                    const sortOrder = sortingModel.sortOrder;

                    groups.forEach(group => {
                        const exactDate = group.date;

                        group.groupOptions
                            .sort((o1, o2) => {
                                if ('ASC' === sortOrder) {
                                    return getPrice(o1, exactDate) - getPrice(o2, exactDate);
                                }

                                return getPrice(o2, exactDate) - getPrice(o1, exactDate);
                            });

                    });
                }
            }
        }

        return groups;
    };

    findPreviousGroupIndex = (groups) => {
        const {config} = this.props;

        const previousIndex = groups.findIndex(g => format(g.date, FORMAT_MASKS.DEFAULT_DATE, true) === config.previousSelection.previousPreferredDate);

        return previousIndex !== -1 ? previousIndex : this.calculateInitiallySelectedGroupIndex(config, groups);
    };

    calculateInitiallySelectedGroupIndex = (config, groups) => {
        const {sortingModel} = config;

        if (sortingModel && sortingModel.orderBy === "DATE" && sortingModel.sortOrder === "DESC") {
            const index = this.findGroupWithFirstOption(groups.slice().reverse());
            const count = groups.length - 1;
            return index >= 0 ? count - index : index;
        }

        return this.findGroupWithFirstOption(groups);
    };

    findGroupWithFirstOption = (groups) => {
        return groups.findIndex(g => g.groupOptions.find(go => go.optionOrder === 0));
    };

    getAdditionalContent = () => {
        return <p>
            <TextWrapper id="greenChoice.linkToWuunder.before"/>
            <a className="footer__greenchoice-link" target={"_blank"}
               href={this.props.config.language === 'nld' ? WUUNDER_GREENCHOICE_URL : WUUNDER_GREENCHOICE_URL_EN}>
                <TextWrapper id="greenChoice.linkToWuunder.middle"/>
            </a>
            <TextWrapper id="greenChoice.linkToWuunder.after"/>
        </p>;
    };

    render() {
        const {onSelectOption, config, isExactDateTabVisible} = this.props;
        const {activeGroup} = this.state;

        const groups = this.groupOptionsByDate();

        const greenOptionsPresent = hasOptionWithGreenDate(this.props.options);

        return (
            groups && groups.length > 0 ?
                <section className="body__tabs tabs day-select" id="day-picker">

                    <SelectDayDropdown optionGroups={groups}
                                       activeGroup={activeGroup}
                                       onSelectGroup={this.onSelectGroup}/>

                    <SelectDayCarousel optionGroups={groups}
                                       activeGroup={activeGroup}
                                       onSelectGroup={this.onSelectGroup}/>

                    <div className="tabs__panels day-select__panels">

                        {
                            groups.map((group, index) => {
                                let isSelected = index === activeGroup;
                                let groupClassName = ClassNames("tabs__panels__panel day-select__panel panel", {"panel--selected": isSelected});

                                const exactDateOptions = group.groupOptions;
                                const greenOptionsPresentInCurrentDay = !!exactDateOptions?.find(o => isDateGreenForOption(group.date, o));

                                const shouldShowFooter = (isExactDateTabVisible && greenOptionsPresent) || greenOptionsPresentInCurrentDay;

                                return (
                                    <div className={groupClassName}
                                         id={"day-picker__panel--" + index}
                                         aria-labelledby={"day-picker__btn--" + index}
                                         role="tabpanel"
                                         aria-hidden={!isSelected}>
                                        <div className="day-select__tab-content">
                                            {
                                                isSelected &&
                                                <RawDateContainer options={group.groupOptions}
                                                                  exactDate={group.date}
                                                                  config={config}
                                                                  onSelectOption={onSelectOption}
                                                                  showGreenChoice={greenOptionsPresentInCurrentDay}/>
                                            }
                                        </div>
                                        {
                                            shouldShowFooter &&
                                            <div>
                                                <FooterForm id={"greenChoice.description"}
                                                            showWithoutFooterText={true}
                                                            config={config}
                                                            additionalContent={this.getAdditionalContent()}
                                                            icon={greenChoiceIcon}/>
                                            </div>
                                        }
                                    </div>
                                );
                            })
                        }

                    </div>

                </section> :

                <TextWrapper id="shippingOptions.optionsNotFound"/>

        );
    }
}